import { Component, inject, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { lastValueFrom, map } from 'rxjs';
import { PersonDetail, SubscriberInfo } from 'src/app/admin-api';
import { AddressControllerService } from 'src/app/admin-api/api/addressController.service';
import { Address } from 'src/app/admin-api/model/address';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';
import {
  AddressSaveResult,
  shippingPriceChangeMessage
} from 'src/app/services/person-address.util';
import { FormUtil } from 'src/app/utils/form.util';

@Component({
  selector: 'app-address-info',
  templateUrl: './address-info.component.html',
  styleUrl: './address-info.component.scss',
  providers: [DialogService]
})
export class AddressInfoComponent implements OnInit {
  @Input()
  person: PersonDetail | undefined;

  @Input()
  subscribers: Array<SubscriberInfo> = [];

  public addressControllerService = inject(AddressControllerService);
  private messageService = inject(MessageService);

  addresses: Address[] = [];

  async ngOnInit(): Promise<void> {
    await this.loadAddresses();
  }

  async loadAddresses(): Promise<void> {
    if (!this.person?.personId) {
      this.addresses = [];
      return;
    }

    LoaderService.showLoader();
    try {
      const result = await lastValueFrom(
        this.addressControllerService
          .getAddress(this.person.personId)
          .pipe(map((data) => data.result))
      );
      this.addresses = result ?? [];
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }

  async onAddressSaved(result: AddressSaveResult): Promise<void> {
    await this.loadAddresses();
    const freightMessage = shippingPriceChangeMessage(
      result.previousShippingPrice,
      result.address?.shippingPrice
    );
    if (freightMessage) {
      AppDialogService.showInfoDialog({
        header: 'Frete recalculado',
        message: freightMessage
      });
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso',
      detail: 'Endereço atualizado.'
    });
  }

  get billingAddresses(): Array<Address> {
    const billingAddresses = this.addresses.filter(
      (address) => address.addressType === Address.AddressTypeEnum.BILLING
    );

    billingAddresses?.sort((a, b) => {
      return (
        FormUtil.utcDate(b.dateUpdated).getTime() -
        FormUtil.utcDate(a.dateUpdated).getTime()
      );
    });

    return billingAddresses;
  }

  get shippingAddresses(): Array<Address> {
    const shippingAddresses = this.addresses.filter(
      (address) => address.addressType === Address.AddressTypeEnum.SHIPPING
    );

    shippingAddresses?.sort((a, b) => {
      return (
        FormUtil.utcDate(b.dateUpdated).getTime() -
        FormUtil.utcDate(a.dateUpdated).getTime()
      );
    });

    return shippingAddresses;
  }
}
